import React, { ReactNode } from 'react';

export const closeSVG: ReactNode = (
  <svg
    width="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="12" fill="#F7F7F8" />
    <path
      d="m16.667 8.274-.94-.94L12 11.06 8.273 7.333l-.94.94L11.06 12l-3.727 3.727.94.94L12 12.94l3.727 3.727.94-.94L12.94 12l3.727-3.726Z"
      fill="#4B4950"
    />
  </svg>
);
